import React from 'react';
import { Link } from 'react-router-dom';

interface SidebarItemProps {
    icon: React.ReactNode;
    label: string;
    path: string;
    isActive: boolean;
    onClick: () => void;
    isCollapsed: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
                                                     icon,
                                                     label,
                                                     path,
                                                     isActive,
                                                     onClick,
                                                     isCollapsed
                                                 }) => {
    return (
        <Link
            to={path}
            onClick={onClick}
            className={`sidebar-legal-item group ${
                isActive ? 'sidebar-legal-item-active' : ''
            }`}
            title={isCollapsed ? label : undefined}
        >
            <span className={`flex-shrink-0 transition-colors duration-300 ${
                isActive ? 'text-gold-300' : 'text-slate-300'
            }`}>
                {icon}
            </span>
            {!isCollapsed && (
                <span className="font-medium transition-opacity duration-300">{label}</span>
            )}

            {/* Tooltip para sidebar colapsado */}
            {isCollapsed && (
                <div className="absolute left-16 top-1/2 transform -translate-y-1/2 bg-navy text-white px-3 py-2 rounded-lg text-sm opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200 z-50 whitespace-nowrap shadow-legal-lg">
                    {label}
                </div>
            )}
        </Link>
    );
};

export default SidebarItem;